const e = {
  "By using this chat, you agree to our terms and privacy policy.": "By using this chat, you agree to our terms and privacy policy.",
  "Type a reply...": "Type a reply..."
};
export {
  e as default
};
//# sourceMappingURL=en.5B0BABAZ.js.map
